import React from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { FlashIcon } from "../../icons/FlashIcon";
import type { MSHatData } from "../../../types";

interface AHSCompletionContentProps {
  hat: MSHatData;
  onContinue: () => void;
  xpValue: number;
}

const ContentContainer = styled(Box, {
  label: "AHSCompletionContentContainer",
})(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(4),
  width: "100%",
  maxWidth: "800px",
}));

const SubTitle = styled(Typography, {
  label: "AHSCompletionSubTitle",
})(({ theme }) => ({
  fontFamily: "Proxima Nova",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "36px",
  color: "#ffffff",
  textAlign: "center",
  marginBottom: theme.spacing(2),
  "@media (max-width: 900px)": {
    fontSize: "20px",
    lineHeight: "30px",
  },
}));

const XPSection = styled(Box, {
  label: "AHSCompletionXPSection",
})(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const XPText = styled(Typography, {
  label: "AHSCompletionXPText",
})(() => ({
  fontFamily: "Proxima Nova",
  fontWeight: 600,
  fontSize: "18px",
  lineHeight: "28px",
  color: "#22C55E",
}));

const ContinueButton = styled(Button, {
  label: "AHSCompletionContinueButton",
})(({ theme }) => ({
  backgroundColor: "#078dee",
  color: "#ffffff",
  fontFamily: "Proxima Nova",
  fontWeight: 700,
  fontSize: "15px",
  lineHeight: "26px",
  padding: theme.spacing(1.5, 3),
  borderRadius: theme.spacing(1),
  minWidth: "120px",
  height: "48px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#0570c4",
  },
}));

export const AHSCompletionContent = ({
  hat,
  onContinue,
  xpValue,
}: AHSCompletionContentProps) => (
  <ContentContainer>
    <SubTitle>
      You&apos;ve explored the paths after high school for becoming a{" "}
      {hat.displayName}
    </SubTitle>

    <XPSection>
      <FlashIcon width={24} color="#22C55E" />
      <XPText>You earned {xpValue} XP</XPText>
    </XPSection>

    <ContinueButton onClick={onContinue}>Continue</ContinueButton>
  </ContentContainer>
);
